import React from 'react'
import { Tooltip } from '@chakra-ui/react'
import { Tag, TagLabel, TagLeftIcon, type TagProps } from '@chakra-ui/react'
import { FiUser } from 'react-icons/fi'
import { FaMobileButton } from 'react-icons/fa6'

type ClientPortalAppFields = {
    has_portal_account: boolean
    has_mobile_app: boolean
}

interface Props {
    client: ClientPortalAppFields
    size?: TagProps['size']
}

export default function ClientPortalAppTags({ client, size = 'sm' }: Props) {
    return (
        <>
            <PortalAccountTag
                hasPortalAccount={client.has_portal_account}
                size={size}
            />
            <MobileAppTag hasMobileApp={client.has_mobile_app} size={size} />
        </>
    )
}

function PortalAccountTag({
    hasPortalAccount,
    size,
}: {
    hasPortalAccount: boolean
    size?: TagProps['size']
}) {
    return (
        <Tooltip
            hasArrow
            rounded="md"
            label={
                hasPortalAccount
                    ? 'This client has a Chckvet portal account'
                    : 'This client does not have a portal account'
            }
        >
            <Tag size={size} colorScheme={hasPortalAccount ? 'brand' : 'gray'}>
                <TagLeftIcon as={FiUser} />
                <TagLabel>{hasPortalAccount ? 'Portal' : 'No portal'}</TagLabel>
            </Tag>
        </Tooltip>
    )
}

function MobileAppTag({
    hasMobileApp,
    size,
}: {
    hasMobileApp: boolean
    size?: TagProps['size']
}) {
    return (
        <Tooltip
            hasArrow
            rounded="md"
            label={
                hasMobileApp
                    ? 'This client has logged into the Chckvet mobile app'
                    : 'This client has not logged into the mobile app'
            }
        >
            <Tag size={size} colorScheme={hasMobileApp ? 'blue' : 'gray'}>
                <TagLeftIcon as={FaMobileButton} />
                <TagLabel>{hasMobileApp ? 'App' : 'No app'}</TagLabel>
            </Tag>
        </Tooltip>
    )
}
